import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function PublicRoute({ children }) {
    const auth = useSelector((state) => state.auth);
    const isAuthenticated = !!auth.accessToken;

    if (isAuthenticated) {
        return <Navigate to="/" />;
    }
    return children || <Outlet />;
}
